// ----------------------------------------------------------------------

const shape = {
  borderRadius: 4,
  borderRadiusSm: 8,
  borderRadiusMd: 8
};

export default shape;
